import css from "../../style/visionStyle.module.css";

const NextButton = ({ text, onClick, isDisabled = false }) => {
  return (
    <div
      className={css?.squareButton}
      role="button"
      disabled={isDisabled}
      style={{
        backgroundColor: isDisabled ? "#9e9ac7" : "#34318C",
        cursor: isDisabled ? "default" : "pointer",
      }}
      onClick={isDisabled ? undefined : onClick}
    >
      <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
        <span className="text-[16px] text-[#F6F6FD] font-semibold ">
          {text}
        </span>
        <img src="\images\NewUiIcons\arrowicon.svg" alt="Arrow Icon" />
      </span>
    </div>
  );
};

export default NextButton;
